import { FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: '',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    key: 'PartNumber',
    //cell: 'navigation',
    field: FIELDS.PART_NUMBER,
    title: 'Part Number',
    label: 'Part Number',
    sortable: true,
    hidden: false,
    locked: true,
    width: 150,
  },
  {
    key: 'vendorPartNumber',
    field: FIELDS.VENDOR_PART_NUMBER,
    title: 'Vendor Part No',
    label: 'Vendor Part No',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: 'NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: 'Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'HarmonizedCode',
    field: FIELDS.HARMONIZED_CODE,
    title: 'Harmonized Code',
    label: 'HarmonizedCode',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'internalPn',
    field: FIELDS.INTERNAL_PN,
    title: 'Internal Pn',
    label: 'Internal Pn',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'inventoryId',
    field: FIELDS.INVENTORY_ID,
    title: 'Inventory Id',
    label: 'Inventory Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ManufacturerName',
    field: FIELDS.MANUFACTURER_NAME,
    title: 'Manufacturer Name',
    label: 'ManufacturerName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: 'Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'companyId',
    field: FIELDS.COMPANY_ID,
    title: 'Company Id',
    label: 'Company Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'companyName',
    field: FIELDS.COMPANY_NAME,
    title: 'Company Name',
    label: 'Company Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: 'Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'conditionId',
    field: FIELDS.CONDITION_ID,
    title: 'Condition Id',
    label: 'Condition Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: 'UOM',
    label: 'UOM',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: 'Package',
    label: 'Package',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: 'Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'physPkg',
    field: FIELDS.PHYS_PKG,
    title: 'Packaging',
    label: 'Packaging',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: 'Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: 'Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PartComments',
    field: FIELDS.PART_COMMENTS,
    title: 'Part Comments',
    label: 'PartComments',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'OnHand',
    field: FIELDS.ON_HAND,
    title: 'On Hand',
    label: 'OnHand',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Allocated',
    field: FIELDS.ALLOCATED,
    title: 'Allocated',
    label: 'Allocated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Available',
    field: FIELDS.AVAILABLE,
    title: 'Available',
    label: 'Available',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Returned',
    field: FIELDS.RETURNED,
    title: 'Returned',
    label: 'Returned',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Destroyed',
    field: FIELDS.DESTROYED,
    title: 'Destroyed',
    label: 'Destroyed',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Warehouse',
    field: FIELDS.WAREHOUSE,
    title: 'Warehouse',
    label: 'Warehouse',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Location',
    field: FIELDS.LOCATION,
    title: 'Location',
    label: 'Location',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Rack',
    field: FIELDS.RACK,
    title: 'Rack',
    label: 'Rack',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Shelf',
    field: FIELDS.SHELF,
    title: 'Shelf',
    label: 'Shelf',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Bin',
    field: FIELDS.BIN,
    title: 'Bin',
    label: 'Bin',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: 'Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: 'Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: 'Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: 'Condition Name',
    label: 'Condition Name',
    sortable: true,
    hidden: false,
    width: 150,
  },

  {
    key: 'CountryOfOriginId',
    field: FIELDS.COUNTRY_OF_ORIGIN_ID,
    title: 'Country Of Origin Id',
    label: 'Country Of Origin Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: 'Country Of Origin Name',
    label: 'Country Of Origin Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'IsQuarantined',
    field: FIELDS.IS_QUARANTINED,
    title: 'Quarantined',
    label: 'Quarantined',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'customerId',
    field: FIELDS.CUSTOMER_ID,
    title: 'Customer Id',
    label: 'Customer Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'customerName',
    field: FIELDS.CUSTOMER_NAME,
    title: 'Customer Name',
    label: 'Customer Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    cell: 'formatDate',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    cell: 'formatDate',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedyUserFullName',
    field: FIELDS.MODIFIEDY_USER_FULL_NAME,
    title: 'Modifiedy User Full Name',
    label: 'ModifiedyUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
